module.exports = __webpack_public_path__ + "img/gz.0d8ff8b6.png";